module.exports = __webpack_public_path__ + "static/media/gear-inactive.e49aad9e.svg";